// test2743
(2743 && 0);
